
	import {
		Request
	} from '@/api/request';
	import {
		defineComponent,
		ref,
		reactive,
		inject,
		provide,
		onMounted,
		watch,
	} from "vue";
	import { useRoute, useRouter } from 'vue-router'
    import {
        getCouponList, permissionList
    } from "@/api/http";

	const columnList: Array < any > = [{
			prop: "title",
			label: "优惠券标题",
			width: 100,
		},
		{
			prop: "type_text",
			label: "优惠类型",
			width: 160,
		},
		{
			prop: "term_text",
			label: "有效时间",
			width: 160,
		},
		{
			prop: "grant_text",
			label: "发放数量",
			width: 100,
		},
	];
	
	const distributionRules: any = {
		user_id: [
			{required: true, message: '请输入用户名称', trigger: 'blur'},
		],
		coupon_id: [
			{required: true, message: '请选择优惠卷', trigger: 'change'},
		],
		
	}

	export default defineComponent({
		name: "operateCoupon",


		setup() {
			const setTitle: any = inject("setTitle");
			setTitle(["优惠卷管理"]);
			let pageSize = ref(10),
				currentPage = ref(1),
				orderStatus = ref(0),
				loading = ref(false),
				total = ref(0),
				headClass = inject("headClass"),
				project = ref([]),
				Router = useRouter(),
                roleList = ref({} as any),
				tableData = ref([] as Array <any> ),
				selectGroup = reactive({
					status: "",
					date: "",
					search: "",
				}),
				screenParameter: any = {
					page: currentPage.value,
					limit: pageSize.value,
					search: ''
				},
				is_dialog = ref(false),
				distributionForm:any =  ref({
					user_id: '',
					coupon_id: '',
					member: '',
				}),
				distributionFormRef = ref(null),
				distributionForm_isload = ref(false),
				distributionList = ref([] as Array <any> )

			let getTableData = () => {
					loading.value = true;
                    let mydata = {
                        type:1,
                        role_name:'operate_coupon',
                    };
                    permissionList(mydata).then((res:any)=>{
                        roleList.value = res?.content?.list || 0;
                    });
					getCouponList(screenParameter).then((res: any) => {
						var list = res?.content?.list || []
						for (var i = 0; i < list.length; i++)
							list[i].status = list[i].status == 1 ? true : false
						tableData.value = list;
						project.value = res?.content?.project || [];
						loading.value = false;
						total.value = res?.content?.total || 0;
					});
				},
				handleSizeChange = (value: number): void => {
					pageSize.value = value;
					getTableData();
				},
				handleCurrentChange = (pageSize: number): void => {
					currentPage.value = pageSize;
					getTableData();
				},
				columnChange = (id: number, type: boolean) => {
					Request.axiosInstance({
						url: 'adminapi/Coupon/upState',
						data: {
							coupon_id: id,
							status: type
						}
					}).then((res: any) => {
						console.log(res)
					})
				},
				screenChange = (e: string | Array < any > , key: any): void => {
					if (!e) {
						delete screenParameter[key];
					} else {
						if (key == "start_date") {
							let date = [];
							screenParameter["start_date"] = new Date(
								e[0]
							).getTime();
							screenParameter["end_date"] = new Date(e[1]).getTime();
						} else {
							screenParameter["search"] = e as string;
						}
					}
					getTableData();
				},
				_distribution = () => {
					is_dialog.value = true
					distributionForm_isload.value = true
					getCouponList({status: '1'}).then((res: any) => {
						var list = res?.content?.list || []
						distributionList.value = list
						distributionForm_isload.value = false
					});
					
				},
				_distributionformSubmit = () => {
					
					(distributionFormRef.value as any).validate((valid: boolean) => {
						if(!valid) return
						distributionForm_isload.value = true
						Request.axiosInstance({
							url: "adminapi/Coupon/grant",
							data: distributionForm.value
						}).then((res: any) => {
							distributionForm_isload.value = false
							is_dialog.value = false
						})
						
				
					})
				},
				_option = (url: string , data: any) => {
					Router.push({
						path: url,
						query: data
					})
				
				}

			onMounted(() => {
				getTableData();
			});

			watch(orderStatus, (newValue, oldValue) => {
				//screenParameter.status = orderStatusNav[newValue].id;
				getTableData();
			});

			return {
				selectGroup,
				pageSize,
				currentPage,
				orderStatus,
				columnList,
				loading,
				tableData,
				project,
				handleSizeChange,
				handleCurrentChange,
				total,
				columnChange,
				headClass,
				screenChange,
				is_dialog,
				_distribution,
				_distributionformSubmit,
				distributionForm,
				distributionList,
				distributionForm_isload,
				distributionFormRef,
				distributionRules,
				_option,
                roleList
			};
		},
	});
